"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var big = function big(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", theme.spacing[7], ";height:", theme.spacing[7], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:big;"));
};

var small = function small(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", theme.spacing[5], ";height:", theme.spacing[5], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:small;"));
};

var sizes = {
  big: big,
  small: small
};

var base = function base(_ref) {
  var theme = _ref.theme,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/(0, _react.css)("border-radius:50%;flex-shrink:0;display:inline-block;vertical-align:middle;background-color:", color || theme.color.primary.brand, ";", sizes[size](theme), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var styles = {
  base: base
};
exports.styles = styles;
//# sourceMappingURL=Dot.styles.js.map